<div
  class="flex flex-col justify-center items-stretch max-w-full py-4"
  testId="add-attribute-container"
>
  <ng-container *ngIf="showCustomForm; else selectFromTemplate">
    <app-edit-attribute-form [form]="form"></app-edit-attribute-form>
    <div
      class="flex flex-row justify-start items-center justify-center items-center"
    >
      <button
        mat-flat-button
        color="primary"
        (click)="create()"
        testId="add-attribute-save"
      >
        Save
      </button>
      <button mat-flat-button (click)="cancel()" testId="add-attribute-cacnel">
        Cancel
      </button>
    </div>
  </ng-container>
  <ng-template #selectFromTemplate>
    <div class="flex flex-col justify-center items-stretch max-w-full gap-4">
      <p>Select a template or define your own custom tracked attribute.</p>
      <div
        class="grid grid-cols-1 md:grid-cols-3 justify-start items-center gap-4"
      >
        <button
          *ngFor="let option of templateOptions"
          mat-flat-button
          (click)="createFromTemplate(option.key)"
          testId="add-attribute-template-{{ option.key }}"
        >
          {{ option.label }}
        </button>
        <button
          mat-flat-button
          (click)="showCustomForm = true"
          testId="add-attribute-custom"
        >
          Custom
        </button>
      </div>
    </div>
  </ng-template>
</div>
